import React from 'react';
import { Button } from '@vimily/bonjoro-ui-components';
import { faArrowUp, faArrowDown } from '@fortawesome/pro-solid-svg-icons';

import ProgressBar from '~/App/Components/ProgressBar';

import { createFontAwesomeIcon } from '~/App/Components/Attributes/util';

const ArrowUp = createFontAwesomeIcon(faArrowUp);
const ArrowDown = createFontAwesomeIcon(faArrowDown);

export type ProgressBarWithNavProps = {
  completedSteps: number;
  stepsCount: number;
  currentStep: number;
  onNextStep: (force?: boolean | undefined) => void;
  onPreviousStep: (force?: boolean | undefined) => void;
  isStepComplete: (stepIndex: number) => boolean;
};

export default function ProgressBarWithNav({
  completedSteps,
  stepsCount,
  currentStep,
  onNextStep,
  onPreviousStep,
  isStepComplete,
}: ProgressBarWithNavProps) {
  return (
    <div
      className='flex justify-center items-center w-full h-[70px] font-bold bg-neutral-100 text-neutral-500'
      id='typeform-action-container'
    >
      <div className='w-[640px] flex justify-between'>
        <div
          className='w-1/3 flex flex-col justify-center pt-2.5 px-2.5 md:px-0'
          id='typeform-progress-container'
        >
          Step {completedSteps + 1}/{stepsCount}
          <ProgressBar>
            <ProgressBar
              nested
              now={currentStep}
              max={stepsCount}
              className='!bg-turquoise-700 mb-0'
            />
          </ProgressBar>
        </div>
        <div className='flex h-2/4 pt-2.5 px-2.5 md:px-0'>
          <Button
            style={{ marginRight: '10px' }}
            disabled={completedSteps === 0}
            onClick={() => onPreviousStep()}
          >
            <ArrowUp />
          </Button>
          <Button
            disabled={
              currentStep === stepsCount || !isStepComplete(completedSteps)
            }
            onClick={() => onNextStep()}
          >
            <ArrowDown />
          </Button>
        </div>
      </div>
    </div>
  );
}
